import { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { MenuItem } from './styled'
import { Context } from 'contexts/context'
import breakpoints from 'styles/breakpoints'

const Component = (props) => {
  const { toggle, setToggle } = useContext(Context)

  const handleClick = () => {
    if (window.innerWidth <= parseInt(breakpoints.desktop)) {
      setToggle(false)
    }
  }

  return (
    <MenuItem className={toggle ? 'open' : 'closed'}>
      <NavLink to={props.path} activeClassName="active-menu" onClick={handleClick}>
        <span>{props.icon}</span>
        <p>{props.label}</p>
      </NavLink>
    </MenuItem>
  )
}

export default Component
